module.exports = __webpack_public_path__ + "static/media/ZillaSlab-Light.34de766a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-Light.eot
// module id = 2804
// module chunks = 51